import { render, staticRenderFns } from "./TransferSetting.vue?vue&type=template&id=15a37478&scoped=true&"
import script from "./TransferSetting.vue?vue&type=script&lang=js&"
export * from "./TransferSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a37478",
  null
  
)

export default component.exports